/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, serializeInvoiceDto, serializeRecordPaymentRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type RecordPaymentRequest } from '../../../../models/index.js';
// @ts-ignore
import { type WithPaymentItemRequestBuilder, WithPaymentItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices/{invoiceId}/payments
 */
export interface PaymentsRequestBuilder extends BaseRequestBuilder<PaymentsRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.invoices.item.payments.item collection
     * @param paymentId Unique identifier of the item
     * @returns {WithPaymentItemRequestBuilder}
     */
     byPaymentId(paymentId: string) : WithPaymentItemRequestBuilder;
    /**
     * Adds a payment to an invoice and re-derives the invoice's status from what is now owed: still Issued while nothing has settled, PartiallyPaid while a balance remains, and Paid once it reaches zero. The invoice must already be issued — a draft is refused, as are voided and cancelled invoices — the amount must be greater than zero, and its currency must match the invoice's. A payment recorded as Completed (the default) may not exceed the outstanding balance, so overpayment is refused rather than absorbed. Record it as Pending instead when the processor has not settled yet: a pending payment is stored but counts for nothing until the complete endpoint is called, so the invoice stays Issued and its balance is unchanged. An unrecognised method is stored as Other and an unrecognised status as Completed, neither of which is an error — send a documented value to be sure of the outcome. Payments accumulate, so an invoice may hold several.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: RecordPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Adds a payment to an invoice and re-derives the invoice's status from what is now owed: still Issued while nothing has settled, PartiallyPaid while a balance remains, and Paid once it reaches zero. The invoice must already be issued — a draft is refused, as are voided and cancelled invoices — the amount must be greater than zero, and its currency must match the invoice's. A payment recorded as Completed (the default) may not exceed the outstanding balance, so overpayment is refused rather than absorbed. Record it as Pending instead when the processor has not settled yet: a pending payment is stored but counts for nothing until the complete endpoint is called, so the invoice stays Issued and its balance is unchanged. An unrecognised method is stored as Other and an unrecognised status as Completed, neither of which is an error — send a documented value to be sure of the outcome. Payments accumulate, so an invoice may hold several.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: RecordPaymentRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PaymentsRequestBuilderUriTemplate = "{+baseurl}/api/invoices/{invoiceId}/payments";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PaymentsRequestBuilderNavigationMetadata: Record<Exclude<keyof PaymentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byPaymentId: {
        navigationMetadata: WithPaymentItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["paymentId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PaymentsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: PaymentsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeRecordPaymentRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
